import React, { PropsWithChildren, useState } from "react"

import { capitalize, Popper } from "@mui/material"
import { styled } from "@mui/styles"

import { useTranslations } from "@cirrus/core/i18n/provider"
import { Avatar } from "@cirrus/ui-kit-ts"

import { getDateRelative } from "../../../helpers/getDateRelative"
import { Name } from "../styled/Name"
import { IMentionedUserInfo } from "../types/IMentionedUserInfo"

export const UserTooltip = ({
                              children,
                              name,
                              avatarUrl,
                              role,
                              ...props
                            }: PropsWithChildren<IMentionedUserInfo & { role?: string }>) => {
  const [anchorElement, setAnchorElement] = useState(null)
  const { i18n } = useTranslations()

  const close = () => setAnchorElement(null)
  const show = (event) => setAnchorElement(event.currentTarget)

  return <div>
    <div onMouseOver={show}
         onMouseOut={close}>
      {children}
    </div>

    <StyledPopper
      anchorEl={anchorElement}
      open={!!anchorElement}
      placement="bottom">

      <StyledWrapper>
        <Avatar title={name} picUrl={avatarUrl} />
        <div>
          <NameInfo>
            <Name>{name}</Name>
            <Status color={props.isOnline ? "success" : "default"} />
          </NameInfo>
          <div>{role}</div>
          <LastSeen>
            {
              props.isOnline
                ? capitalize(i18n("General:online"))
                : `${i18n("General:LastSeen")}: ${getDateRelative(props.lastSeen) || i18n("General:Unknown")}`
            }
          </LastSeen>
        </div>
      </StyledWrapper>
    </StyledPopper>
  </div>
}

const StyledPopper = styled(Popper)({
  zIndex: 100,
  width: "26rem"
})

const StyledWrapper = styled("div")({
  background: "#fff",
  padding: ".8rem 1rem",
  borderRadius: ".4rem",
  display: "flex",
  gap: ".8rem",
  boxShadow: "0 .1rem 2rem 0 rgba(0, 0, 0, .1)"
})

const NameInfo = styled("div")({
  display: "flex",
  gap: ".4rem"
})

const LastSeen = styled("div")({
  fontSize: "1.2rem",
  fontStyle: "italic",
  color: "#737373"
})

const Status = styled("div")(({ color }) => ({
  width: ".8rem",
  height: ".8rem",
  backgroundColor: color === "success" ? "#008859" : "#79747E",
  borderRadius: "50%",
  display: "flex",
  alignSelf: "center"
}))
